import React, { useEffect, useState, useContext } from 'react'
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'
import ExpandCollapseIcon from '../ui-elements/ExpandCollapseIcon'
import Card from '../ui-elements/Card'
import FormatChecklistTitle from '../dashboard/FormatChecklistTitle'
import LoopThroughQuestions from '../dashboard/LoopThroughQuestions'
import FormatCheckPeriodStartedBy from '../dashboard/FormatCheckPeriodStartedBy'
import FormatCheckPeriodInProgress from '../dashboard/FormatCheckPeriodInProgress'


type Props = {
    checklistId: string
    thisChecklist: ObjectStringKeyAnyValue
    checkPeriodId: string
    thisCheckPeriod: ObjectStringKeyAnyValue
    expandedByDefault?: boolean
}

function CollapsableCheckPeriodSummary({
    checklistId,
    thisChecklist,
    checkPeriodId,
    thisCheckPeriod,
    expandedByDefault = false
}: Props) {

    const {
        tableData,
        t
    } = useContext(GlobalContext)

    const [isExpanded, setIsExpanded] = useState(expandedByDefault)
    const completedAnswers = thisCheckPeriod && thisCheckPeriod.Progress && thisCheckPeriod.Progress.completed_answers && parseInt(`${thisCheckPeriod.Progress.total_answers}`)
    const totalAnswers = thisCheckPeriod && thisCheckPeriod.Progress && thisCheckPeriod.Progress.total_answers && parseInt(`${thisCheckPeriod.Progress.total_answers}`)
    const showProgress = thisCheckPeriod && thisCheckPeriod.Progress && totalAnswers !== completedAnswers



    return <Card fullwidth={true}>
        <div className={`w-full flex flex-col gap-4`}>
            <div className={`w-full flex flex-row justify-between gap-2`}>
                <div className={`flex flex-col`}>
                    <FormatChecklistTitle
                        thisChecklistPeriod={thisCheckPeriod}
                        thisChecklist={thisChecklist}
                        classString={`text-lg font-righteous text-brandblue`}
                        showCheckPeriodTimes={true}
                        showCompletedCheck={true}
                    />
                    {showProgress ? <p className={`text-xs`}>
                        {t('ProcessPages.CollapsableCheckPeriodSummary.progress', { completed: completedAnswers, total: totalAnswers })}
                    </p> : null}
                </div>
                <ExpandCollapseIcon
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />
            </div>

            <FormatCheckPeriodStartedBy
                thisChecklistPeriod={thisCheckPeriod}
                thisChecklist={thisChecklist}
            />

            <FormatCheckPeriodInProgress
                thisChecklistPeriod={thisCheckPeriod}
            />

            {isExpanded && <LoopThroughQuestions
                checkPeriodId={checkPeriodId}
                thisChecklist={thisChecklist}
                questionFormat={'compact'}
            />}
        </div>

        {/* <Link to={`/checklists/${checkPeriodId}`}>Go</Link> */}
    </Card>
}

export default CollapsableCheckPeriodSummary